var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('card',{attrs:{"back":""}},[_c('template',{slot:"header"},[_c('h3',[_vm._v("ثبت ماموریت")]),_c('hr')]),_c('template',{slot:"content"},[_c('requests',{attrs:{"Column":_vm.columns,"FormId":3,"rowForEdit":_vm.rowForEdit?JSON.parse(_vm.rowForEdit):null}})],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }